/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 10:42:23
 * @LastEditTime: 2021-09-28 17:16:30
 * @LastEditors: wangshengqiang
 * @Description: 投保人健康告知
 */

/* eslint-disable no-unused-expressions */
import React, { useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import Content from '@/components/Content';
import { Iconfont } from '@/baseComponents';
import { useNotice } from '../../hook'; // "insured"
// "holder"

const Text = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    planId
  } = props;
  const {
    className,
    maxLength,
    buttonText,
    showType = 'expand'
  } = attrs;
  const [notice = {}] = useNotice({
    noticeObjectType: 'insured',
    planId
  });
  const [showMore, setShowMore] = useState(false);
  const {
    header = '',
    noticeDetailList = []
  } = notice || {};
  const cls = classnames({
    'components-text-render': true,
    [className]: !!className
  });
  const data = useMemo(() => {
    if (showMore) {
      return noticeDetailList;
    }

    if (maxLength) {
      return noticeDetailList.slice(0, maxLength);
    }

    return noticeDetailList;
  }, [showMore, noticeDetailList, maxLength]);

  const onClickFooter = () => setShowMore(!showMore);

  useEffect(() => {
    setShowMore(showType === 'expand');
  }, [showType]);

  const renderHeader = () => {
    const dangerouslySetInnerHTML = {
      __html: header
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "text-header",
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    });
  };

  const renderBody = () => {
    const html = data.reduce((res = '', item = {}) => {
      const {
        noticeContent = ''
      } = item;
      return `${res}<div style="opactity: 0; height: 15px;"></div>${noticeContent}`;
    }, '');
    const dangerouslySetInnerHTML = {
      __html: html
    };
    return /*#__PURE__*/React.createElement(Content, {
      className: "text-body",
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    });
  };

  const renderFooter = () => {
    if (!maxLength) {
      return null;
    }

    if (maxLength >= noticeDetailList.length) {
      return null;
    }

    const footerCls = classnames({
      'text-footer': true,
      reverse: !!showMore
    });
    return /*#__PURE__*/React.createElement("div", {
      className: footerCls,
      onClick: onClickFooter
    }, /*#__PURE__*/React.createElement(Iconfont, {
      className: "icon",
      type: "biansechakangengduo"
    }), /*#__PURE__*/React.createElement("div", {
      className: "footer-title",
      "data-title": buttonText
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, renderHeader(), renderBody(), renderFooter());
});
export default Text;